import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "create-dialog-panel" }
const _hoisted_2 = { class: "create-dialog-panel__header" }
const _hoisted_3 = { class: "create-dialog-panel__header-photo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "create-dialog-panel__header-photo-liter"
}
const _hoisted_7 = {
  key: 3,
  class: "create-dialog-panel__header-photo-liter"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "create-dialog-panel__header-photo-liter"
}
const _hoisted_11 = {
  key: 3,
  class: "create-dialog-panel__header-photo-liter"
}
const _hoisted_12 = { class: "create-dialog-panel__header-body" }
const _hoisted_13 = { class: "create-dialog-panel__header-body-name" }
const _hoisted_14 = { class: "create-dialog-panel__header-body-buttons" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "create-dialog-panel__header-photo-conference"
}
const _hoisted_17 = { class: "create-dialog-panel__header-body" }
const _hoisted_18 = { class: "create-dialog-panel__header-body-name" }
const _hoisted_19 = { class: "create-dialog-panel__header-body-buttons" }
const _hoisted_20 = { class: "create-dialog-panel__search" }
const _hoisted_21 = { class: "create-dialog-panel__search-field" }
const _hoisted_22 = { class: "create-dialog-panel__search-persons" }
const _hoisted_23 = {
  key: 0,
  class: "search-persons__group"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "search-persons__group-item-cred" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "search-persons__group-item-cred-photo"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 1,
  class: "search-persons__group-list"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "search-persons__group-name" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "search-persons__group-item-cred" }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "search-persons__group-item-cred-photo"
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = {
  key: 2,
  class: "search-persons__empty-results"
}

import {
	computed,
	nextTick,
	onMounted,
	ref,
	watch
} from 'vue';
import {
	ChatUser,
	UserWorker
} from "@/store/chats";
import { headerStore } from "@/store/header";
import AppLoader from "@/components/common/AppLoader.vue";
import ChatAvatarModal from "@/components/main/chat-panel/modals/ChatAvatarModal.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import FileInput from "@/components/file/FileInput.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { highlightSearchText } from "@/utils/textHelpers";
import { resolvePhotoUrl } from "@/utils/urlHelpers";
import { ChatsApi } from "@/ api/ChatsApi";
import { workerStore } from "@/store/worker";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderChatCreateDialogPanel',
  setup(__props) {

const store = headerStore()
const userStore = workerStore()

const $inputRef = ref<InstanceType<typeof FileInput> | null>(null);
const $avatarModal = ref<typeof ChatAvatarModal | null>(null)
const loading = ref(false);
const searchText = ref("")
const conferenceImg = ref<string | null>(null)
const conferenceName = ref("Новая беседа")
const isConferenceNameEdited = ref(false)
const selectAll = ref(false)
const selectedPersonsIds = ref<number[]>([])
const editModel = ref()

const selectedPersonsArray = computed(() =>
	selectedPersonsIds.value
		.map(id => findUser(id))
		.filter(user => !!user))

const conferenceImgUrl = computed(() =>
	conferenceImg.value
		? !conferenceImg.value.includes('https')
			? `${process.env.VUE_APP_API_OLD_URL}/${conferenceImg.value}`
			: conferenceImg.value
		: ""
)

const chatUsers = computed(() => store.getChatUsers)
const users = computed(() => {
	if (mode.value === 'edit-chat'  && !editedChat.value?.IsPersonal) {
		return [
			...editModel.value?.ExistingWorkers.map(worker =>
				worker.Id === currentUser.value?.Id
					? { ...worker, AlwaysSelected: true }
					: worker
			) || [],
			...chatUsers.value || []
		]
	}

	return chatUsers.value
})
const mode = computed(() => store.getChatMode)
const editedChat = computed(() => store.getEditedChat)
const currentUser = computed(() => userStore.workerProfile)

const listItemsCount = computed(() => {
	if (!users.value) return 0

	let count  = 0
	users.value.forEach(user => {
		if (!user.Department) {
			if (user.Worker) {
				if (user.Worker.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			} else {
				if (user.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			}
		} else {
			user.Department.Workers.forEach(worker => {
				if (worker.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			})
		}
	})

	return count
})

watch(chatUsers, (newVal) => {
	if (newVal) {
		newVal.forEach(person => {
			if (!person.Department) {
				if (person.Worker.AlwaysSelected) {
					selectedPersonsIds.value.push(person.Worker.Id)
				}
			} else {
				person.Department.Workers.forEach(worker => {
					if (worker.AlwaysSelected) {
						selectedPersonsIds.value.push(worker.Id)
					}
				})
			}
		})

		if (mode.value === 'edit-chat' && !editedChat.value?.IsPersonal) {
			editModel.value.ExistingWorkers.forEach(person => {
				if (person.AlwaysSelected) {
					selectedPersonsIds.value.push(person.Id)
				}
			})
		}
	}
})

const togglePerson = (id: number) => {
	if (selectedPersonsIds.value.includes(id)) {
		selectedPersonsIds.value.splice(selectedPersonsIds.value.indexOf(id), 1)
	} else {
		selectedPersonsIds.value.push(id)
	}
}

const toggleAllPersons = (state: boolean, force?: boolean) => {
	const newState = force ? !selectAll.value : state
	if (newState) {
		selectAll.value = true
		const allPersons: number[] = []
		users.value?.forEach(person => {
			if (!person.Department) {
				allPersons.push(person.Worker ? person.Worker.Id : person.Id)
			} else {
				person.Department.Workers.forEach(worker => {
					allPersons.push(worker.Id)
				})
			}
		})

		selectedPersonsIds.value = allPersons
	} else {
		selectAll.value = false
		const alwaysSelectedUsers: number[] = []
		users.value?.forEach(person => {
			if (!person.Department) {
				if (person.Worker?.AlwaysSelected) {
					alwaysSelectedUsers.push(person.Worker.Id)
				} else if (person.AlwaysSelected) {
					alwaysSelectedUsers.push(person.Id)
				}
			} else {
				person.Department.Workers.forEach(worker => {
					if (worker.AlwaysSelected) {
						alwaysSelectedUsers.push(worker.Id)
					}
				})
			}
		})

		selectedPersonsIds.value = alwaysSelectedUsers
	}
}

const allUsersFromGroupSelected = (group: ChatUser) => {
	if (group.Department) {
		const selectedWorkers = group.Department.Workers.filter(worker => selectedPersonsIds.value.includes(worker.Id))
		return selectedWorkers.length === group.Department.Workers.length
	} else {
		return false
	}
}

const toggleGroupPersons = (group: ChatUser, state: boolean, force?: boolean) => {
	const newState = force ? !allUsersFromGroupSelected(group) : state
	if (newState) {
		group.Department?.Workers.forEach(worker => {
			if (!selectedPersonsIds.value.includes(worker.Id)) {
				selectedPersonsIds.value.push(worker.Id)
			}
		})
	} else {
		group.Department?.Workers.forEach(worker => {
			if (selectedPersonsIds.value.includes(worker.Id) && !worker.AlwaysSelected) {
				selectedPersonsIds.value.splice(selectedPersonsIds.value.indexOf(worker.Id), 1)
			}
		})
	}
}

const editConferenceName = () => {
	isConferenceNameEdited.value = true
	nextTick(() => $inputRef.value.focus())
}

const isShowSingleUser = (group: ChatUser) => {
	return group.Worker
		? group.Worker.Name.toUpperCase().includes(searchText.value.toUpperCase())
		: group.Name.toUpperCase().includes(searchText.value.toUpperCase())
}
const isShowDepartmentUser = (group: UserWorker) => {
	return group.Name.toUpperCase().includes(searchText.value.toUpperCase())
}

const isShowDepartmentUsers = (group: ChatUser) => {
	return !!group.Department?.Workers.find(worker => worker.Name.toUpperCase().includes(searchText.value.toUpperCase()))
}

const highlightText = (name: string) => {
	return highlightSearchText(searchText.value, name)
}

const findUser = (id: number): ChatUser | UserWorker | null => {
	let searchedUser = null
	users.value?.forEach(user => {
		if (!user.Department) {
			if (user.Worker?.Id === id) {
				searchedUser = user
			} else if (user.Id === id) {
				searchedUser = user
			}
		} else {
			user.Department.Workers.forEach(worker => {
				if (worker.Id === id) {
					searchedUser = worker
				}
			})
		}
	})

	return searchedUser
}

const getUserName = (idx: number) => {
	return selectedPersonsArray.value[idx]?.Worker
		? selectedPersonsArray.value[idx]?.Worker.Name
		: selectedPersonsArray.value[idx]?.Name
}

const onBackToChatList = () => {
	store.setMode('list')
}

const createChatWithYouOrOneFriend = async (index: number) => {
	const user = findUser(selectedPersonsIds.value[index])
	try {
		if (user) {
			loading.value = true;
			const response = await ChatsApi.createChatWithYouOrOneFriend(user.Worker?.Id || user.Id)
			await store.updateDialogInList(getCurrentDate())
			store.addOpenedChatsHistory({
				Id: response.Id,
				Name: user?.Worker?.Name || user.Name,
				ScrollTop: 0
			});
			store.setMode('chat')
			await store.setOpenedChat(response.Id)
		}
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const createConference = async () => {
	try {
		loading.value = true;
		let response = {
			Id: editedChat.value?.Id
		};

		if (mode.value === 'edit-chat') {
			if (editedChat.value?.IsPersonal && selectedPersonsIds.value.length > 2) {
				response = await ChatsApi.convertPersonalChatToConference({
					name: conferenceName.value,
					photolink: conferenceImgUrl.value,
					workers: selectedPersonsIds.value,
					chatId: editedChat.value.Id
				})
			} else {
				const prevExistWorkers = editModel.value.ExistingWorkers.map(ew => ew.Id)
				await ChatsApi.editConference({
					name: conferenceName.value,
					photolink: conferenceImgUrl.value,
					chatId: editedChat.value?.Id as number,
					workersToAdd: selectedPersonsIds.value.filter(sp => !prevExistWorkers.includes(sp)),
					workerToRemove: prevExistWorkers.filter(worker => !selectedPersonsIds.value.includes(worker)),
				})
			}
		} else {
			response = await ChatsApi.createConferenceWithUsers({
				name: conferenceName.value,
				photolink: conferenceImgUrl.value,
				workers: selectedPersonsIds.value
			})
		}

		await store.updateDialogInList(getCurrentDate())
		store.addOpenedChatsHistory({
			Id: response.Id as number,
			Name: conferenceName.value,
			ScrollTop: 0
		});
		if (mode.value === 'edit-chat') {
			await store.setOpenedChat(editedChat.value?.Id as number, null, true)
		} else {
			await store.setOpenedChat(response.Id as number)
		}
		store.setMode('chat')
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const exitChat = async () => {
	try {
		loading.value = true;
		await ChatsApi.exitConference(editedChat.value?.Id as number)
		await store.updateDialogInList(getCurrentDate())
		store.setMode('list')
		store.setOpenedChat(null)
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const getCurrentDate = () => {
	const date = new Date();

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

watch(conferenceName, (newVal) => {
	if (!newVal) {
		conferenceName.value = "Новая беседа";
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

onMounted(async () => {
	try {
		loading.value = true;
		if (mode.value === 'edit-chat' && !editedChat.value?.IsPersonal) {
			editModel.value = await ChatsApi.getChatSettings(editedChat.value?.Id!)
			conferenceImg.value = editModel.value.Photolink || null
			conferenceName.value = editModel.value.Name || null
			store.setChatUsers(editModel.value.PotentialWorkerHolders)
			selectedPersonsIds.value = editModel.value.ExistingWorkers.map(worker => worker.Id)
		} else {
			store.fetchChatUsers(mode.value === 'edit-chat'
				? editedChat.value?.Id
				: 0
			)
		}
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChatAvatarModal, {
      ref_key: "$avatarModal",
      ref: $avatarModal,
      title: "Загрузка аватара чата",
      onSave: _cache[0] || (_cache[0] = ($event: any) => (conferenceImg.value = $event))
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (!users.value || loading.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (selectedPersonsIds.value.length < 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                (selectedPersonsIds.value.length === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (selectedPersonsArray.value[0]?.Worker?.PhotoLink)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(resolvePhotoUrl)(selectedPersonsArray.value[0]?.Worker?.PhotoLink),
                            alt: "photo"
                          }, null, 8, _hoisted_4))
                        : (selectedPersonsArray.value[0]?.PhotoLink)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _unref(resolvePhotoUrl)(selectedPersonsArray.value[0]?.PhotoLink),
                              alt: "photo"
                            }, null, 8, _hoisted_5))
                          : (selectedPersonsArray.value[0]?.Worker)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(selectedPersonsArray.value[0]?.Worker.PhotoLiter), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(selectedPersonsArray.value[0]?.PhotoLiter), 1))
                    ], 64))
                  : (selectedPersonsIds.value.length === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (selectedPersonsArray.value[1]?.Worker?.PhotoLink)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(resolvePhotoUrl)(selectedPersonsArray.value[1]?.Worker?.PhotoLink),
                              alt: "photo"
                            }, null, 8, _hoisted_8))
                          : (selectedPersonsArray.value[1]?.PhotoLink)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _unref(resolvePhotoUrl)(selectedPersonsArray.value[1]?.PhotoLink),
                                alt: "photo"
                              }, null, 8, _hoisted_9))
                            : (selectedPersonsArray.value[1]?.Worker)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(selectedPersonsArray.value[1]?.Worker.PhotoLiter), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(selectedPersonsArray.value[1]?.PhotoLiter), 1))
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(getUserName(selectedPersonsIds.value.length === 1 ? 0 : 1)), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: "create-dialog-panel__btn",
                    onClick: onBackToChatList
                  }, " Отмена "),
                  (selectedPersonsIds.value.length === 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "create-dialog-panel__btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (createChatWithYouOrOneFriend(0)))
                      }, " Перейти "))
                    : (selectedPersonsIds.value.length === 2)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "create-dialog-panel__btn",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (createChatWithYouOrOneFriend(1)))
                        }, " Перейти к чату "))
                      : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "create-dialog-panel__header-photo",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($avatarModal.value.onOpen()))
              }, [
                (conferenceImg.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: conferenceImgUrl.value,
                      alt: "photo"
                    }, null, 8, _hoisted_15))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(AppIcon, {
                        class: "create-dialog-panel__header-photo-conference-icon",
                        name: "photo-add",
                        width: "30px",
                        color: "#979797",
                        "hover-color": "#3F884F",
                        cursor: "pointer"
                      })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (isConferenceNameEdited.value)
                    ? (_openBlock(), _createBlock(FileInput, {
                        key: 0,
                        ref_key: "$inputRef",
                        ref: $inputRef,
                        modelValue: conferenceName.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((conferenceName).value = $event)),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (isConferenceNameEdited.value = false))
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(conferenceName.value) + " ", 1),
                        _createVNode(AppTooltip, { text: "Редактировать" }, {
                          activator: _withCtx(() => [
                            (!isConferenceNameEdited.value)
                              ? (_openBlock(), _createBlock(AppIcon, {
                                  key: 0,
                                  name: "edit-pencil",
                                  size: "18px",
                                  color: "#979797",
                                  "hover-color": "#499259",
                                  cursor: "pointer",
                                  onClick: editConferenceName
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    class: "create-dialog-panel__btn",
                    onClick: onBackToChatList
                  }, " Отмена "),
                  _createElementVNode("span", {
                    class: "create-dialog-panel__btn",
                    onClick: createConference
                  }, _toDisplayString(mode.value === 'edit-chat' ? editedChat.value.IsPersonal ? 'Преобразовать в группу' : 'Сохранить' : 'Создать группу'), 1)
                ])
              ]),
              (editModel.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "create-dialog-panel__header-exit",
                    onClick: _withModifiers(exitChat, ["stop"])
                  }, [
                    _createVNode(AppIcon, {
                      class: "create-dialog-panel__header-exit-icon",
                      name: "logout",
                      width: "16px",
                      color: "#D05A4F",
                      title: "Покинуть группу"
                    }),
                    _cache[13] || (_cache[13] = _createTextVNode(" Покинуть группу "))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "create-dialog-panel__search-field-label" }, " Участники чата ", -1)),
          _createVNode(AppInput, {
            class: "create-dialog-panel__search-field-input",
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchText).value = $event)),
            placeholder: "Поиск",
            "show-search-button": ""
          }, null, 8, ["modelValue"])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "create-dialog-panel__search-field-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_22, [
          (listItemsCount.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: _normalizeClass({
							'search-persons__group-item': true,
							'search-persons__group-item--select-all': true
						}),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleAllPersons(null, true)))
                }, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "search-persons__group-name" }, " Все пользователи ", -1)),
                  _createVNode(AppCheckbox, {
                    text: "",
                    value: selectAll.value,
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (toggleAllPersons($event))),
                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["value"])
                ])
              ]))
            : _createCommentVNode("", true),
          (listItemsCount.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(users.value, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "search-persons__group",
                  key: group.Position
                }, [
                  (!group.Department && isShowSingleUser(group))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({
								'search-persons__group-item': true,
								'search-persons__group-item--single': true
							}),
                        onClick: ($event: any) => (togglePerson(group.Worker.Id))
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          (group.Worker?.PhotoLink || group.PhotoLink)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "search-persons__group-item-cred-img",
                                src: _unref(resolvePhotoUrl)(group.Worker ? group.Worker.PhotoLink : group.PhotoLink),
                                alt: "Avatar"
                              }, null, 8, _hoisted_26))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(group.Worker?.PhotoLiter || group.PhotoLiter), 1)),
                          _createElementVNode("div", {
                            class: "search-persons__group-item-cred-name",
                            innerHTML: highlightText(group.Worker?.Name || group.Name)
                          }, null, 8, _hoisted_28)
                        ]),
                        _createVNode(AppCheckbox, {
                          text: "",
                          value: selectedPersonsIds.value.includes(group.Worker?.Id || group.Id),
                          disabled: group.Worker?.AlwaysSelected || group.AlwaysSelected,
                          onInput: ($event: any) => (togglePerson(group.Worker?.Id || group.Id)),
                          onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["value", "disabled", "onInput"])
                      ], 8, _hoisted_24))
                    : (isShowDepartmentUsers(group))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
									'search-persons__group-item': true,
									'search-persons__group-item--select-all': true
								}),
                            onClick: ($event: any) => (toggleGroupPersons(group, $event, true))
                          }, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(group.Department.Name), 1),
                            _createVNode(AppCheckbox, {
                              text: "",
                              value: allUsersFromGroupSelected(group),
                              onInput: ($event: any) => (toggleGroupPersons(group, $event)),
                              onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, ["value", "onInput"])
                          ], 8, _hoisted_30),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Department?.Workers, (person) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: person.Id
                            }, [
                              (isShowDepartmentUser(person))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "search-persons__group-item",
                                    onClick: ($event: any) => (togglePerson(person.Id))
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      (person.PhotoLink)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "search-persons__group-item-cred-img",
                                            src: _unref(resolvePhotoUrl)(person.PhotoLink),
                                            alt: "Avatar"
                                          }, null, 8, _hoisted_34))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(person.PhotoLiter), 1)),
                                      _createElementVNode("div", {
                                        class: "search-persons__group-item-cred-name",
                                        innerHTML: highlightText(person.Name)
                                      }, null, 8, _hoisted_36)
                                    ]),
                                    _createVNode(AppCheckbox, {
                                      text: "",
                                      value: selectedPersonsIds.value.includes(person.Id),
                                      disabled: person.AlwaysSelected,
                                      onInput: ($event: any) => (togglePerson(person.Id)),
                                      onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 8, ["value", "disabled", "onInput"])
                                  ], 8, _hoisted_32))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (users.value && !listItemsCount.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, " По запросу ничего не найдено "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})